import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./components/LoginPage";
import Homepage from "./components/Homepage";
import AssetRecorder from "./components/AssetRecorder";
import VideoViewer from "./components/VideoViewer";
import VideoLibrary from "./components/VideoLibrary";
import NotesPage from "./components/NotesPage";
import WeatherPage from "./components/WeatherPage";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<Homepage />} />
          <Route path="/weather" element={<WeatherPage />} />
          <Route
            path="/notes"
            element={
              <ProtectedRoute>
                <NotesPage />
              </ProtectedRoute>
            }
          />
          <Route path="/notes/:note_id" element={<NotesPage />} />
          <Route
            path="/asset_recorder"
            element={
              <ProtectedRoute>
                <AssetRecorder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/asset_library"
            element={
              <ProtectedRoute>
                <VideoLibrary />
              </ProtectedRoute>
            }
          />
          <Route path="/asset_viewer/:asset_id" element={<VideoViewer />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
